import Button from '@/components/Button'
import Icon from '@/components/Icon'
import { MUTATE_DATA } from '@/fragments/GravityForms'
import {
  handleCaptcha,
  handleInputChange,
  handleSubfieldsInputChange,
  useFieldValues,
  useOptionsState
} from '@/utilities/gravityForms/gfFieldsInputHandlers'
import { validateOnSubmit } from '@/utilities/gravityForms/gfFieldsValidation'
import { useMutation } from '@apollo/client'
import { faArrowRight } from '@fortawesome/sharp-solid-svg-icons'
import { useEffect, useState } from 'react'
import styles from './ContactFormHeader.module.scss'
import FormFields from '../FormFields'

export default function Form(form) {
  const { submitButton, formFields, databaseId } = form.form
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { selectStates, handleFileChange, handleOptionClick, resetSelectStates, toggleDropdown, dropdownRefs } = useOptionsState()
  const { fieldValuesArray, fieldValues, clearForm, updateFieldValue } = useFieldValues(formFields)
  // Add form error state
  const [formError, setFormError] = useState(null)

  //This form uses modal for form submission notification, closes after 4 seconds and clears out form fields
  const [isModalOpen, setModalOpen] = useState(true)

  const [updateData] = useMutation(MUTATE_DATA)

  useEffect(() => {
    let timer
    if (isModalOpen) {
      timer = setTimeout(() => {
        setModalOpen(false)
      }, 4000)
    }
    return () => clearTimeout(timer)
  }, [isModalOpen])

  const clearContactForm = () => {
    clearForm()
    resetSelectStates()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const isValid = validateOnSubmit(formFields, fieldValues)

    if (!isValid) {
      e.stopPropagation()
      setFormError('Please complete all required fields correctly.')
      return
    }

    try {
      setIsSubmitting(true)
      await updateData({
        variables: { fieldValues: fieldValuesArray, databaseId }
      })
      setIsFormSubmitted(true)
      setModalOpen(true)
      clearContactForm()
    } catch (error) {
      console.error('Form submission error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className={styles.contactHeaderForm} id="header-contact-form">
      <div className={styles.GravityForm}>
        {isFormSubmitted ? (
          <div className={styles.confirmationMessage}>
            <h3>Thank You for Your Submission!</h3>
            <p>
              We appreciate your interest in partnering with us. Our team will review your information and get in touch with you soon to
              discuss potential collaboration opportunities.
            </p>
          </div>
        ) : (
          <>
            <h3>Let&apos;s Get Started Today</h3>
            <p className={styles.fieldsRequiredText}>All Fields Required</p>
            <form onSubmit={handleSubmit}>
              <FormFields
                formFields={formFields}
                formState={{
                  fieldValues,
                  fieldValuesArray,
                  updateFieldValue,
                  selectStates,
                  dropdownRefs
                }}
                handlers={{
                  handleInputChange,
                  handleSubfieldsInputChange,
                  handleCaptcha,
                  handleFileChange,
                  handleOptionClick,
                  toggleDropdown
                }}
              />

              {formError && (
                <div className="error-container">
                  <div className={styles.formError}>
                    <p className="error-text">{formError}</p>
                  </div>
                </div>
              )}

              <div className={styles.submit}>
                <Button className={`${styles.formButtons} ${isSubmitting ? styles.disabled : ''}`} disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : submitButton.text}
                  <Icon icon={faArrowRight} className={styles.icon} />
                </Button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
